import {FileProps} from '../../types';
import {MediaPlayer} from './MediaPlayer';
import * as React from 'react';
import {useDropzone} from 'react-dropzone';
import {humanFileSize} from '../../../utils';

import {MediaBox, MediaPreview, MediaGroupContainer, MediaPreviewContainer, MediaPreviewSubtitle} from './MediaComponents.style';

export const UploadVideoFile = (_props: Record<string, unknown>) => {
  const [files, setFiles] = React.useState<FileProps[]>([]);

  React.useEffect(() => () => {
    files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: 'video/*',
    maxFiles: 1,
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file),
        path: file.name
      })));
    }
  });
  
  const thumbs = files.map(file => (
    <div key={file.path}>
      <MediaPlayer src={file.preview} mime={file.type} />
      <MediaPreviewSubtitle>
        {file.path} - {humanFileSize(file.size)}
      </MediaPreviewSubtitle>
    </div>
  ));

  const renderEmptyPreview = () => {
    return(
      <MediaPreview>
        <i className='fal fa-play'></i>
      </MediaPreview>
    )
  }

  return(
    <MediaGroupContainer>
      <MediaPreviewContainer>
        {!!thumbs.length && thumbs}
        {!thumbs.length && renderEmptyPreview()}
      </MediaPreviewContainer>
      <MediaBox {...getRootProps({isDragActive, isDragAccept, isDragReject})}>
        <section className="container">
          <div>
            <input {...getInputProps()} />
            <p>Clique para selecionar ou arraste seu vídeo aqui.</p>
          </div>
        </section>
      </MediaBox>
    </MediaGroupContainer>
  );
}